export function isValidUserData(user) {
    if (user.phone.length > 0 && user.phone.length < 10)
        return false
    return user.firstname && user.lastname
}
